export default {
    find_the_newest_homes_for_sale_in: 'Encuentre las casas más nuevas en venta en',
    reset: 'Restablecer',
    top_cities_in: 'Principales ciudades de',
    real_estate: 'bienes raíces',
    average_price: 'Precio promedio:',
    average_price_per_sqft: 'Precio promedio/pie²:',
    average_days_on_market: 'Días promedio en el mercado:',
    view: 'Ver',
    demand: 'DEMANDA',
    all_cities_in: 'Todas las ciudades de',
    data_based_on_current_averages: '*Datos basados en promedios actuales',
    price: 'Precio*',
    price_per_sqft: 'Precio/pie²*',
    days_on_market: 'Días en el mercado*',
    inventory: 'Inventario',
    homes: 'casas',
    homes_for_sale: 'casas en venta',
    view_less: 'Ver menos',
    view_more: 'Ver más',
    newest_homes_for_sale: 'Casas recién publicadas en',
    all_counties_in: 'Todos los condados de',
    explore_more: 'Explorar más',
    neighborhoods: 'barrios',
    explore_unique_neighborhoods: 'Explora los muchos barrios únicos que',
    has_to_offer: 'tiene para ofrecer.',
    view_neighborhoods: 'Ver barrios',
    zip_codes: 'Códigos ZIP',
    find_homes_in_preferred_area: 'Encuentra casas en tu área preferida.',
    view_zip_codes: 'Ver códigos ZIP',
};
